<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <section ref="content" id="content" class="section">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <h4 v-if="!Object.keys(taps).length" class="title is-size-4 has-text-centered">{{ $t("NoWalletTransactions") }}</h4>
          <template v-for="tap in Object.keys(taps)">
              <p :key="tap.id">{{ tap }}</p>
              <table :key="tap.id" class="table is-bordered is-fullwidth is-size-7">
                  <thead>
                  <tr>
                      <th>Date</th>
                      <th>Tap PPL</th>
                      <th>Litres</th>
                      <th>Total</th>
                      <th>PPL</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="transaction in taps[tap]" :key="transaction.date">
                      <td>{{ new Date(transaction.date).toLocaleString() }}</td>
                      <td>{{ transaction.salesRate }}</td>
                      <td>{{ transaction.litres }}</td>
                      <td>{{ transaction.total }}</td>
                      <td>{{ transaction.ppl }}</td>
                  </tr>
              </tbody>
              </table>
          </template>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";
import _ from "lodash";

export default {
  name: "TagTransactions",
  components: {
    Header,
    Notification,
    NavigationTabs,
    Spinner
  },
  props: {
    _nfcId: String
  },
  mounted: async function()
  {
      try
      {
        const response = await this.$http.get(`/Tags/TransactionDetails/${this._nfcId.toUpperCase()}`);

        if(response.data.transactions.length)
        {
            this.taps = _.groupBy(response.data.transactions, "tap");
        }
      }

      catch(error)
        {
            
        }
  },
  data () {
      return {
          taps: []
      }
  }
};
</script>
